module.exports = __webpack_public_path__ + "static/media/shutterstock_2002025357.8cce8bc1.png";